import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import consignments from './modules/consignments'
import piportalApiSearch from './modules/piportalApiSearch'
import authorization from './modules/authorization'
import reports from './modules/reports'
import groupsUsers from './modules/groupsUsers'
import shippingDisplay from './modules/shippingDisplay'
import activateUser from './modules/activateUser'
import addCompanyData from './modules/addCompanyData'
import addUserData from './modules/addUserData'
import detailing from './modules/detailing'
import statistic from './modules/statistic'
import companies from './modules/companies'
import download from './modules/download'
import fbNews from './modules/fbNews'
import packages from './modules/packages'
import piTransitOtvt from './modules/piTransitOtvt.js'
import packageStatistic from './modules/packageStatistic'
import productClient from './modules/productClient'
import arrOfIcons from '../components/json/arr_of_icons.json'
import otvtOrganizations from './modules/otvtOrganizations'

Vue.use(Vuex)

export const store = new Vuex.Store({
  strict: true,
  state: {
    servers: [],
    tabIndex: 0,
    showMenu: true,
    socket: {
      isConnected: false,
      message: '',
      reconnectError: false
    },
    files: [],
    arrOfIcons: arrOfIcons,
    packageStatuses: null,
    packageDeliveryCodes: null,
    isAdminPart: false,
    screenWidth: null,
    mobile: null,
    tablet: null,
    desktop: null,
    largeDesktop: null
  },
  getters: {
    userProfile: state => state.userInfo,
    mobile: state => state.mobile,
    tablet: state => state.tablet,
    desktop: state => state.desktop,
    largeDesktop: state => state.largeDesktop
  },
  actions: {
    sendMessage (context, message) {
      Vue.prototype.$socket.send(message)
    },
    loadPackageStatuses ({ commit }) {
      axios.get('/api/private/v3.0/list/package/statuses/')
        .then(response => response.data)
        .then(statuses => {
          commit('parsePackageStatuses', statuses)
        })
        .catch(error => {
          console.log(error.statusText)
        })
    },
    loadDeliveryCodes ({ commit }) {
      axios.get('/api/private/v3.0/list/package/deliveries/')
        .then(response => response.data)
        .then(codes => {
          commit('parsePackageDeliveryCodes', codes)
        })
        .catch(error => {
          console.log(error.statusText)
        })
    }
  },
  mutations: {
    setUserData (state, data) {
      state.userInfo = data
      state.servers = data.piportals
      localStorage.setItem('piportals', JSON.stringify(data.piportals))
    },
    tabPlus (state) {
      state.tabIndex++
    },
    tabMinus (state) {
      state.tabIndex--
    },
    toggleMenu (state) {
      if (state.showMenu) {
        state.showMenu = false
      } else {
        state.showMenu = true
      }
    },
    hideMenu (state) {
      state.showMenu = false
    },
    displayMenu (state) {
      state.showMenu = true
    },
    SOCKET_ONOPEN (state, event) {
      Vue.prototype.$socket = event.currentTarget
      state.socket.isConnected = true
      console.log('open connection')
    },
    SOCKET_ONCLOSE (state) {
      state.socket.isConnected = false
    },
    SOCKET_ONERROR (state, event) {
      console.error(state, event)
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE (state, message) {
      state.socket.message = message
      const data = JSON.parse(message.data)
      const prevStatus = state.packageStatuses.filter(status => status.id === data.content.old)[0].name
      const currentStatus = state.packageStatuses.filter(status => status.id === data.content.new)[0].name
      const h = this._vm.$createElement
      const vNodesMsg = h(
        'p',
        { class: ['text-left', 'mb-0'] },
        [
          h('i', { class: 'fas fa-sync-alt' }),
          h('strong', {}, ' Смена статуса: '),
          h('br'),
          ` ${prevStatus} `,
          h('i', { class: 'fas fa-long-arrow-alt-right' }),
          ` ${currentStatus} `
        ]
      )
      const token = localStorage.getItem('token_castle_authorization')
      if (token) {
        this._vm.$bvToast.toast([vNodesMsg], {
          title: 'Пакет №' + data.content.package,
          variant: 'success',
          toaster: 'b-toaster-bottom-right'
        })
      }
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT (state, count) {
      console.info(state, count)
    },
    SOCKET_RECONNECT_ERROR (state) {
      state.socket.reconnectError = true
    },
    updateFiles (state, value) {
      for (let q = 0; q < value.length; q++) {
        value[q].icon = ''
        let ext = ''
        const parts = value[q].name.split('.')
        if (parts.length > 1) ext = parts.pop()
        for (const key in state.arrOfIcons) {
          if (ext.toLowerCase().indexOf(key) !== -1) {
            value[q].icon = state.arrOfIcons[key]
            break
          }
        }
        if (!value[q].icon) {
          value[q].icon = 'fas fa-file'
        }
      }
      state.files = value
    },
    parsePackageStatuses (state, value) {
      for (let i = 0; i < value.length; i++) {
        value[i].label = value[i].name
      }
      state.packageStatuses = value
    },
    parsePackageDeliveryCodes (state, value) {
      state.packageDeliveryCodes = value
    },
    updateScreenWidth (state, value) {
      state.screenWidth = value
    },
    updateMobile (state, value) {
      state.mobile = value
    },
    updateTablet (state, value) {
      state.tablet = value
    },
    updateDesktop (state, value) {
      state.desktop = value
    },
    updateLargeDesktop (state, value) {
      state.largeDesktop = value
    },
    goToAdminPart (state) {
      state.isAdminPart = true
    },
    goToUserPart (state) {
      state.isAdminPart = false
    }
  },
  modules: {
    activateUser,
    addCompanyData,
    addUserData,
    authorization,
    groupsUsers,
    shippingDisplay,
    detailing,
    statistic,
    consignments,
    piportalApiSearch,
    companies,
    download,
    piTransitOtvt,
    reports,
    fbNews,
    packageStatistic,
    packages,
    productClient,
    otvtOrganizations
  }
})
